import {Component, Inject, Input, NgZone, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
// import {CdkTextareaAutosize} from '@angular/cdk';
import {take} from 'rxjs/operators';

@Component({
  selector: 'note-details',
  template: `
    <div>
      <mat-form-field styles="width: 100%;">
        <mat-label>Note</mat-label>
        <textarea matInput maxRows="10" styles="height: 100px; width: 100%;" [(ngModel)]="content"
                  placeholder="Add note"></textarea>
      </mat-form-field>
      <mat-dialog-actions align="end">
        <button mat-button class="left" (click)="closeModal()">Cancel</button>
        <button mat-raised-button color="success" class="right"
                (click)="saveNote()" [disabled]="false">Save</button>
        <button mat-raised-button color="danger" class="right"
                (click)="deleteNote()" [disabled]="false">Delete</button>
      </mat-dialog-actions>

    </div>`,
  styleUrls: ['./note-details.component.scss']
})
export class NoteDetailsComponent {
  content: any;

  constructor(
    public dialogRef: MatDialogRef<NoteDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoteDetailsComponent) {}


    ngOnInit() {
      if (this.data) {
        this.content = this.data;
      }
    }

  closeModal() {
    this.dialogRef.close({close: true});
  }

  saveNote() {
    this.dialogRef.close({content: this.content});
  }

  deleteNote() {
    this.dialogRef.close({delete: true});
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/note-details/note-details.component.ts